import InfoPopoverModule from './info-popover.module'

export default InfoPopoverModule
